import { combineReducers } from 'redux';
import { reducer as realtimePresenceReducer } from './features/realtime/presence';
import { reducer as realtimeUserReducer } from './features/realtime/user';
import { reducer as callInfoReducers } from './features/callInfo';
import { reducer as messagesReducers } from './features/messages';
import { reducer as notificationReducers } from './features/notification';
import { reducer as systemReducers } from './features/system';
import { reducer as analyticsReducers } from './features/analytics';
import { reducer as meetingHistoryReducers } from './features/meeting-history';
import { reducer as dialogsReducers } from '../modules/dialogs';
import { reducer as locationsReducer } from '../modules/settings/tabs/clinic-settings';
import { browserNotificationsReducers } from '../modules/settings/tabs/notifications/reducers';
// direct import is used to avoid circular import,
// do it only here as root reducer is imported everywhere through AppState type
// todo: get rid of AppState or do not use rootReducer to get it.
import banners from '../modules/banners/reducers';
import coreName from '../modules/core/constants/name';
import dialogsName from '../modules/dialogs/constants/name';
import coreReducer from '../modules/core/reducers';
import devices from '../modules/devices/reducers';
import call from '../modules/call/reducers';
import callMobile from '../modules/call-mobile/reducers';
import { MODULE_NAME as extensionFrameworkName } from '../modules/extensions-framework/constants/name';
import { MODULE_NAME as marketplaceConsumerName } from '../modules/marketplace-consumer/constants/name';
import { MODULE_NAME as marketplaceAdminName } from '../modules/marketplace-admin/constants/name';
import extensionFrameworkReducer from '../modules/extensions-framework/reducers';
import marketplaceConsumerReducer from '../modules/marketplace-consumer/reducers';
import marketplaceAdminReducer from '../modules/marketplace-admin/reducers';
import dokbotReducer from '../modules/dokbot/reducers';
import ssoReducer from '../modules/sso/reducers';
import { MODULE_NAME as ssoModuleName } from '../modules/sso/constants';
import localMedia from '../modules/local-media/reducers';
import troubleshooting from '../modules/troubleshooting/reducers';
import { captionsReducer } from '../modules/captions';
const rootReducer = combineReducers({
    banners,
    devices,
    call,
    callMobile,
    captions: captionsReducer,
    localMedia,
    troubleshooting,
    dokbot: dokbotReducer,
    realtime: realtimePresenceReducer,
    user: realtimeUserReducer,
    callInfo: callInfoReducers,
    messages: messagesReducers,
    notification: notificationReducers,
    system: systemReducers,
    analytics: analyticsReducers,
    meetingHistory: meetingHistoryReducers,
    browserNotifications: browserNotificationsReducers,
    locations: locationsReducer,
    [dialogsName]: dialogsReducers,
    [coreName]: coreReducer,
    [extensionFrameworkName]: extensionFrameworkReducer,
    [marketplaceConsumerName]: marketplaceConsumerReducer,
    [marketplaceAdminName]: marketplaceAdminReducer,
    [ssoModuleName]: ssoReducer,
});
export default rootReducer;
